module.exports = __webpack_public_path__ + "static/media/Image 40@2x.48e95acc.png";